
    import './styles.scoped.css';
    export default {
  "direction-button-wrapper": "awsui_direction-button-wrapper_155yk_frrwt_29",
  "direction-button-wrapper-motion-enter": "awsui_direction-button-wrapper-motion-enter_155yk_frrwt_49",
  "direction-button-wrapper-motion-entering": "awsui_direction-button-wrapper-motion-entering_155yk_frrwt_49",
  "direction-button-wrapper-motion-exit": "awsui_direction-button-wrapper-motion-exit_155yk_frrwt_49",
  "direction-button-wrapper-motion-exiting": "awsui_direction-button-wrapper-motion-exiting_155yk_frrwt_49",
  "drag-handle-entry": "awsui_drag-handle-entry_155yk_frrwt_1",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_155yk_frrwt_1",
  "drag-handle-exit": "awsui_drag-handle-exit_155yk_frrwt_1",
  "awsui-motion-fade-out-0": "awsui_awsui-motion-fade-out-0_155yk_frrwt_1",
  "direction-button-wrapper-block-start": "awsui_direction-button-wrapper-block-start_155yk_frrwt_89",
  "direction-button-wrapper-block-end": "awsui_direction-button-wrapper-block-end_155yk_frrwt_93",
  "direction-button-wrapper-inline-start": "awsui_direction-button-wrapper-inline-start_155yk_frrwt_97",
  "direction-button-wrapper-inline-end": "awsui_direction-button-wrapper-inline-end_155yk_frrwt_108",
  "contents": "awsui_contents_155yk_frrwt_119",
  "portal-overlay": "awsui_portal-overlay_155yk_frrwt_123",
  "portal-overlay-disabled": "awsui_portal-overlay-disabled_155yk_frrwt_131",
  "portal-overlay-contents": "awsui_portal-overlay-contents_155yk_frrwt_135",
  "drag-handle": "awsui_drag-handle_155yk_frrwt_139",
  "direction-button-wrapper-hidden": "awsui_direction-button-wrapper-hidden_155yk_frrwt_152",
  "direction-button-wrapper-forced": "awsui_direction-button-wrapper-forced_155yk_frrwt_176",
  "direction-button-wrapper-forced-top-0": "awsui_direction-button-wrapper-forced-top-0_155yk_frrwt_180",
  "direction-button-wrapper-forced-top-1": "awsui_direction-button-wrapper-forced-top-1_155yk_frrwt_184",
  "direction-button-wrapper-forced-top-2": "awsui_direction-button-wrapper-forced-top-2_155yk_frrwt_188",
  "direction-button-wrapper-forced-top-3": "awsui_direction-button-wrapper-forced-top-3_155yk_frrwt_192",
  "direction-button-wrapper-forced-bottom-0": "awsui_direction-button-wrapper-forced-bottom-0_155yk_frrwt_196",
  "direction-button-wrapper-forced-bottom-1": "awsui_direction-button-wrapper-forced-bottom-1_155yk_frrwt_200",
  "direction-button-wrapper-forced-bottom-2": "awsui_direction-button-wrapper-forced-bottom-2_155yk_frrwt_204",
  "direction-button-wrapper-forced-bottom-3": "awsui_direction-button-wrapper-forced-bottom-3_155yk_frrwt_208",
  "direction-button": "awsui_direction-button_155yk_frrwt_29",
  "direction-button-disabled": "awsui_direction-button-disabled_155yk_frrwt_231"
};
  